import { productRecommendationBaseStyles } from "@zoovu/runner-web-design-base";
import globals from "../partials/global-variables";
import stylesConfig from "../styles.config";
import mediaQuery from "../abstract/media-query";

import { Button, ButtonPagination, ButtonPaginationNextBack } from "../partials/buttons";
import { productButtonStyles } from "./product-recommendation-view-style";

const xsHorizontalProductsMargin = {
  marginLeft: "10px",
  marginRight: "10px",
};

export default {
  container: {
    "& .advice-recommended": {
      "&.with-filters": {
        display: "flex",
        flexDirection: "row",
        width: "100%",
        [`@media (${globals.breakpoints.$sm})`]: {
          flexDirection: "column",
        },
        "& .products-wrapper": {
          width: "calc(100% - 250px)",
          [`@media (${globals.breakpoints.$sm})`]: {
            width: "100%",
          }
        },
        "& .filter-panel-advice": {
          width: "250px",
          [`@media (${globals.breakpoints.$xs})`]: {
            ...xsHorizontalProductsMargin,
          },
        },
      },
    },
    "& .product-bundle-wrapper": {
      display: "flex",
      flexWrap: "wrap",
      marginBottom: "10px",
      overflow: "auto",
      "& .carousel": {
        height: "auto",
        "& .hooper-list, & .hooper-track, & .hooper-slide": {
          height: "auto",
          maxHeight: "100%",
        },
        "& .hooper-slide": {
          display: "flex",
          flex: "0 0 auto",
          position: "relative",
        },
        "& .hooper-navigation": {
          "& .hooper-prev, & .hooper-next": {
            ...Button,
            borderColor: stylesConfig.colors.primaryFontColor,
            alignItems: "center",
            borderRadius: 0,
            display: "flex",
            height: "48px",
            justifyContent: "center",
            minWidth: 0,
            position: "absolute",
            padding: 0,
            width: "48px",
            "&.is-disabled": {
              background: "white",
              borderColor: stylesConfig.colors.secondary.spectrum100,
              cursor: "no-drop",
              opacity: 0.4,
            },
            [mediaQuery.hover]: {
              "&:hover": {
                background: globals.colors.white,
              },
            },
            [`@media (${globals.breakpoints.$sm})`]: {
              minWidth: 0,
            },
          },
          "& svg": {
            fill: stylesConfig.colors.primaryFontColor,
            height: "38px",
            width: "38px",
          },
        },
        "& .hooper-track": {
          display: "flex",
          flexFlow: "row nowrap",
          flex: "none",
        },
      },
      "& .product-recommendation-bundle": {
        ...productRecommendationBaseStyles(globals),
        width: "100%",
        [`@media (${globals.breakpoints.$sm})`]: {
          width: "100%",
        },
        [`@media (${globals.breakpoints.$xs})`]: {
          ...xsHorizontalProductsMargin,
        },
      },
    },
    "& .products-bundle-header": {
      alignItems: "center",
      border: "1px solid",
      borderColor: stylesConfig.colors.secondary.spectrum100,
      display: "flex",
      justifyContent: "space-between",
      margin: "15px",
      padding: "5px 10px",
      width: "100%",
      "& .products-bundle-header-text": {
        color: stylesConfig.colors.primaryFontColor,
      },
      "& .products-bundle-header-counter": {
        color: stylesConfig.colors.secondary.spectrum200,
      },
      [`@media (${globals.breakpoints.$xs})`]: {
        flexDirection: "column",
        margin: "10px 0",
        paddingBottom: "15px",
        ...xsHorizontalProductsMargin,
      },
      "& .bundle-navigation": {
        display: "flex",
        alignItems: "center",
        marginRight: "auto",
        marginLeft: "auto",
        [`@media (${globals.breakpoints.$xs})`]: {
          marginBottom: "15px",
        },
        "& .bundle-navigation-button": {
          ...ButtonPagination,
          ...ButtonPaginationNextBack,
        },
        "& .bundle-navigation-counter": {
          marginRight: "10px",
        }
      },
    },
    "& .products-bundle-button": {
      ...productButtonStyles,
      margin: 0,
      width: "auto",
      [`@media (${globals.breakpoints.$xs})`]: {
        width: "auto",
      },
    },
    "& .bundle-top-products": {
      width: "100%",
    },
  },
};
